import styled from 'styled-components';

const h2 = styled.div`
    visibility: ${props => props.hidden ? 'hidden' : 'visible'};
    padding-top: ${props => !props.noPadding ? '1rem' : '0'};
    font-size: 1.5rem;
    color: ${props => !props.invertedColors ? props.theme.colors.primaryText : props.theme.colors.primaryTextInverted};
    font-weight: ${props => props.semiBold ? '500' : '300'};
    text-align: ${props => props.center ? 'center' : 'initial'};

`;

export default h2;

